import type { Period } from '~/api/wikitrade-market'

// 页面状态只描述 K 线工作台的主流程，不和品种弹窗的局部 loading 混用。
export type PageStatus = 'idle' | 'loading' | 'ready' | 'error'

// WebSocket 状态用于右上角行情连接标签，和历史 K 线接口的请求状态分开展示。
export type SocketStatus = 'idle' | 'connecting' | 'live' | 'closed' | 'error'

// 默认品种为空，等待 initconfig 返回后再选第一个可用品种，避免写死某个交易对。
export const DEFAULT_SYMBOL = ''

// 1h 是首屏兼顾数据密度和可读性的默认周期。
export const DEFAULT_PERIOD: Period = '1h'

// 主序列 ID 需要和 @wiki/kline-vue 的缩放、价格线等配置保持一致。
export const MAIN_SERIES_ID = 'wikitrade-main'

// 页面工作台展示用的周期配置，value 直接透传给历史 K 线接口和实时订阅。
// 这里显式绑定 Period 类型，新增周期时可以同时约束接口入参和 UI 选项。
export const PERIOD_OPTIONS: Array<{ value: Period; label: string }> = [
  { value: '1m', label: '1分钟' },
  { value: '5m', label: '5分钟' },
  { value: '15m', label: '15分钟' },
  { value: '30m', label: '30分钟' },
  { value: '1h', label: '1小时' },
  { value: '4h', label: '4小时' },
  { value: '1d', label: '1天' },
  { value: '1w', label: '1周' },
  { value: '1M', label: '1月' },
]

// 不同周期初始可视密度差异较大，单独维护避免散落在 template 里。
// 数字越小，首屏展示的蜡烛越密；分钟线数据多，因此比日线、周线更紧凑。
export const PERIOD_DEFAULT_BAR_SPACING: Record<Period, number> = {
  '1m': 4,
  '5m': 12,
  '15m': 30,
  '30m': 20,
  '1h': 10,
  '4h': 14,
  '1d': 8,
  '1w': 10,
  '1M': 14,
}

export const WS_URL = 'wss://mtwss.tech004.com/connect'

export const SEARCH_ICON_URL =
  'https://resources1.interface003.com/web30/2026/05/19/e1e89d8f-6c86-4291-b3a5-df523f7bacf7.svg'

// WebSocket token 由行情服务的固定 pid/accountId 组合生成。
// accountId 当前为空，代表页面级公共行情订阅；如果后续接入账号隔离，只改这里和 token 生成逻辑。
export const WS_CONFIG = {
  pid: '502',
  accountId: '',
}
